import * as yup from 'yup';

export function getValidationSchema() {
  return yup.object().shape({
    device: yup.object().nullable().required().shape({
      deviceId: yup.string().required(),
      deviceName: yup.string().required(),
    }),
  });
}
